import UI_ProgressBar from './UI_ProgressBar';
import UI_PointsCounter from './UI_PointsCounter';
import UI_GoalPanelCollect from './UI_GoalPanelCollect';
import UI_GoalPanelPoints from './UI_GoalPanelPoints';
import UI_ExtraMovesBuyButton from './UI_ExtraMovesBuyButton';

export default class UI_TopBar extends Phaser.Group {
  /**
   * This is the top bar of the game state. Has all the piececs
   * @param {LvlObject} gameplayController
   * @param {Object} levelData
   */
  constructor(gameplayController, levelData) {
    super(game);
    const showLevelAsHard = levelData && levelData.showAsHard;
    this.bg = G.makeImage( // Accessed externally
      320, -2,
      showLevelAsHard ? 'gameplay_top_bar_background_hard' : 'gameplay_top_bar_background_normal',
      [0.5, 0],
      this,
    );

    this.progressBar = new UI_ProgressBar(132, 110); // Accessed Externally

    // Accessed externally
    this.movesTxt = new G.Text(G.OMTsettings.elements.UI_TopBar.movesTxt.x || 130, 80, OMT.language.getText('Moves'), G.OMTsettings.elements.UI_TopBar.movesTxt.style, [0.5, 0], 85);
    this.add(this.movesTxt);

    // The individual amount of moves you  have left
    this._movesAmountTxt = new G.Text(G.OMTsettings.elements.UI_TopBar.movesAmountTxt.x || 130, 100, gameplayController.moves, G.OMTsettings.elements.UI_TopBar.movesAmountTxt.style, [0.5, 0], 160);
    this.add(this._movesAmountTxt);

    // Accessed externally
    if (levelData.goal[0] === 'collect') {
      this.goalPanel = new UI_GoalPanelCollect(410, 50); // Collecting gems
    } else {
      this.goalPanel = new UI_GoalPanelPoints(410, 50); // Collecting points
    }
    this.pointsCounter = new UI_PointsCounter(G.OMTsettings.elements.UI_GoalPanelPoints.pointsCounter.x || 405, G.OMTsettings.elements.UI_GoalPanelPoints.pointsCounter.y || 105); // Accessed externally

    if (UI_ExtraMovesBuyButton.willItShow()) { // Check if it'll show before creating
      this._extraMovesBtn = new UI_ExtraMovesBuyButton(gameplayController);
      this._extraMovesBtn.x = 250;
      this._extraMovesBtn.targetY = 100;
    }

    this._signalBindings = [];
    this._signalBindings.push(G.sb('changeMoveNumber').add(() => {
      this._movesAmountTxt.setText(gameplayController.moves.toString());
    }));

    this._signalBindings.push(G.sb('onScreenResize').add(this._onScreenResize.bind(this)));

    this._onScreenResize();
  }

  /**
   * Destroy!
   */
  destroy() {
    if (this._signalBindings) {
      this._signalBindings.forEach((binding) => {
        if (binding.detach) {
          binding.detach();
        }
      });
      this._signalBindings = null;
    }
    if (this._extraMovesBtn) {
      this._extraMovesBtn.destroy();
    }
    this.progressBar.destroy();
    if (this._hand) {
      this._hand.destroy();
    }
    super.destroy();
  }

  /**
   * Has a resize function but it doesn't do anything...
   */
  _onScreenResize() {
    // Nothing?
  }

  /**
   * Makes the hand appear and points to a specific spot
   * @param {string} key
   */
  showSuggestion(key) {
    if (!this._hand) {
      this._hand = new Phaser.Group(game);
      const handImg = G.makeImage(0, 0, 'tut_hand', [24 / 90, 11 / 98], this._hand);
      this._hand.handTween = game.add.tween(handImg)
        .to({ y: 15 }, 1000, Phaser.Easing.Sinusoidal.InOut, true, 0, -1, true);
    }
    game.world.addChild(this._hand);
    this._hand.visible = true;

    let targetPosition;
    switch (key) {
      case 'points':
        targetPosition = {
          obj: this.pointsCounter,
          offset: { x: 0, y: 0 },
        };
        break;
      case 'goal':
        targetPosition = {
          obj: this.goalPanel,
          offset: { x: 0, y: 0 },
        };
        break;
      case 'moves':
        targetPosition = {
          obj: this._movesAmountTxt,
          offset: { x: this.movesTxt.width / 2, y: this._movesAmountTxt.height },
        };
        break;
      default: break;
    }

    if (targetPosition) {
      const converted = game.world.toLocal({ x: targetPosition.obj.x, y: targetPosition.obj.y }, targetPosition.obj.parent);
      this._hand.x = converted.x + (targetPosition.obj.width * 0.3) + targetPosition.offset.x;
      this._hand.y = converted.y + (targetPosition.obj.height * 0.1) + targetPosition.offset.y;
    }
  }

  /**
   * Hides the hand
   */
  hideSuggestion() {
    if (this._hand) {
      this._hand.visible = false;
    }
  }
}
